import { TouristImportPage } from "@/pages/stammdaten/TouristImportPage";

interface TouristImportIntegrationPanelProps {
  canWrite: boolean;
}

export function TouristImportIntegrationPanel({ canWrite }: TouristImportIntegrationPanelProps) {
  return <TouristImportPage inIntegration canWrite={canWrite} />;
}
